<div *ngIf="tenGameClubs$ | async as tenGameClub" class="attendance-card rounded overflow-hidden shadow">
  <div class="attendance-header d-flex align-items-center justify-content-between p-2 border-bottom border-info">
    <h4 class="font-size-14 mb-0">Game Attendance</h4>
    <fgb-ten-game-club-score [total]="tenGameClub.length"></fgb-ten-game-club-score>
  </div>
  <div class="attendance-body">
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="panel-content">
          <div *ngFor="let game of tenGameClub" class="ten-game-club-container">
            <div class="ten-game-club">
              <span class="svg" *ngIf="game.GameAttended" [inlineSVG]="'assets/images/icons/games-attendance.svg'"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
